//import { pre } from "framer-motion/client";
import React, { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";

export const IcligmQuots = ({ user, setSignout, setUserData, iquotAccessed }) => {
  const compregkeyid1 = user?.compregkeyid || '';
  const [compregkeyid, setCompregkeyid] = useState(compregkeyid1); // Initialize compregkeyid state
  const [pageMsgs, setPageMsgs] = useState('Welcome');
  const [prodlist, setProdlist] = useState(false); // to fetch data only once
  const [chargenm, setChargenm] = useState([]);
  const [softlic, setSoftlic] = useState([]);
  const [usrlic, setUsrlic] = useState([]);
  const [compd, setCompd] = useState([]);
  const [inputValues, setInputValues] = useState({});
  const [showTips, setShowTips] = useState('Welcome');
  const [showModTips, setShowModTips] = useState('');
  const [basert, setBasert] = useState(0);
  const [totalAmt, setTotalAmt] = useState(0);
  const [priceMap, setPriceMap] = useState({});
  const [validUsrs, setValidUsrs] = useState(true);
  const [selectedRepoLot, setSelectedRepoLot] = useState(null);
  const [resetButton, SetResetButton] = useState(false);
  const topRef = useRef(null);
  const [emailFlag, setEmailFlag] = useState(false);
  const [email, setEmail] = useState(user?.email || ''); // Initialize email state
  const [mobile, setMobile] = useState(user?.mobile || ''); // Initialize mobile state
  const [emailData, setEmailData] = useState(''); // Initialize emailData state
  const [companyName, setCompanyName] = useState(user?.companyName || ''); // Initialize companyName state
  const [enablePrintQuotation, setEnablePrintQuotation] = useState(false); // Initialize enablePrintQuotation state
  const [forceDisable, setForceDisable] = useState(false); //to disable Save button manually after email is sent

  useEffect(() => { //setting user credentials after successfull logIn 
    if (iquotAccessed && user && user.compregkeyid) {
      setCompregkeyid(user.compregkeyid);
      setEmail(user.email || '');
      setMobile(user.mobile || '');
      setCompanyName(user.companyName || '');
      console.log("Company" + user.companyName);
      console.log("Mobile" + mobile);
    } else {
      console.log("⚠️ user is null or has no compregkeyid" + iquotAccessed + " " + user);
      setCompregkeyid('');
    }
  }, [iquotAccessed, user, mobile]);

  //Validating user
  useEffect(() => {
    if (iquotAccessed) {
      if (user === null) {
        console.log("User is not logged in.");
        setCompregkeyid('');
        setTimeout(() => {
          window.location.href = "#logindemo";
        }, 100);
      }
      else {
        console.log("User is logged in.");
        setPageMsgs('Welcome to ICLIGM - ICLIGM Software Quotations');
        setProdlist(true);
      }
    }
  }, [user, iquotAccessed]);

  // Product list API
  useEffect(() => {
    const fetchData = async () => {
      try {
        console.log('Fetching data...');
        //add timestamp to API to avoid caching issues
        const timeStamp = new Date().getTime(); // Get current timestamp
        const response = await fetch(`https://servguest.eximon.com/SqServlet?app=react_iq1&compregkeyid=${encodeURIComponent(compregkeyid)}&timestamp=${timeStamp}`);
        const text = await response.text();
//        console.log("Fetched Text:", text.toString()); // log to inspect manually 
        let json;
        try {
          json = JSON.parse(text);
        } catch (parseErr) {
          console.error("❌ JSON parse error:", parseErr.message);
          return;
        }
                 console.log("Parsed JSON:", json); // log to inspect manually 
        if (Array.isArray(json?.epc) && json.epc.length > 0) {
          console.log("EPC data found:", json.epc); // log to inspect manually
          const chargenmValues = json.epc.map(item => ({
            keyid: item.keyid,
            chargenm: item.chargenm?.trim() ?? "",
            tips: item.tips?.trim() ?? ""
          }));
          setChargenm(chargenmValues);
        } else {
          console.warn("No EPC data found in JSON.");
        }
        if (Array.isArray(json?.emod) && json.emod.length > 0) {
          console.log("Emod data found:", json.emod); // log to inspect manually
          const emodValues = json.emod.map(item => ({
            keyid: item.keyid,
            pckeyid: item.pckeyid?.trim() ?? "",
            tips: item.tips?.trim() ?? "",
            softnm: item.softnm?.trim() ?? "",
            basert: item.basert?.trim() ?? ""
          }));
          setSoftlic(emodValues);
        } else {
          console.warn("No Emod data found in JSON.");
        }
        if (Array.isArray(json?.eusrlic) && json.eusrlic.length > 0) {
          console.log("eusrlic data found:", json.eusrlic); // log to inspect manually
          const eusrlicValues = json.eusrlic.map(item => ({
            keyid: item.keyid,
            pckeyid: item.pckeyid?.trim() ?? "",
            fromf: item.fromf?.trim() ?? "",
            tof: item.tof?.trim() ?? "",
            usrrt: item.usrrt?.trim() ?? ""
          }));
          setUsrlic(eusrlicValues);
        } else {
          console.warn("No userlic data found in JSON.");
        }
        if (Array.isArray(json?.ecompd) && json.ecompd.length > 0) {
          console.log("ecompd data found:", json.ecompd); // log to inspect manually
          const ecompdValues = json.ecompd.map(item => ({
            keyid: item.keyid,
            details: item.details?.trim() ?? "",
            tips: item.tips?.trim() ?? "",
            comprt: item.comprt?.trim() ?? ""
          }));
          setCompd(ecompdValues);
          setProdlist(false);
        } else {
          console.warn("No ecompd data found in JSON.");
        }

      } catch (error) {
        console.error('Error fetching data:', error);
        setProdlist(false);
      }
    };
    if (prodlist && compregkeyid !== '')  // Fetch data only if prodlist is true and compregkeyid is available
    {
      fetchData();
    }
  }, [prodlist, compregkeyid]);

  const isSaveEnabled = () => { //Save quotation button enable conditions
    if (forceDisable) {
      return false; // If forceDisable is true, always disable
    }
    const hasSoftlic26 = priceMap.hasOwnProperty("softlic-26"); //SaaS
    const hasSoftlic1or2 = priceMap.hasOwnProperty("softlic-1") || priceMap.hasOwnProperty("softlic-2") || priceMap.hasOwnProperty("softlic-3") || priceMap.hasOwnProperty("softlic-29");

    const hasCompd1 = priceMap.hasOwnProperty("compd-1");
    const hasCompd7 = priceMap.hasOwnProperty("compd-7");

    console.log("hasSoftlic26:", hasSoftlic26);
    console.log("hasCompd1:", hasCompd1);
    console.log("hasCompd7:", hasCompd7);
    console.log("hasSoftlic1or2:", hasSoftlic1or2);
    console.log("Save condition:", (hasSoftlic26 || hasSoftlic1or2) && hasCompd1 && hasCompd7);
    // Main condition
    return (hasSoftlic26 || hasSoftlic1or2) && hasCompd1 && hasCompd7;
  };

  const handleSaveQuotation = () => {
    const combinedData = Object.entries(priceMap).map(([key, value]) => {
      const isInputKey = key.startsWith("input-");
      const isCompdKey = key.startsWith("compd-");
      // const isSoftKey = key.startsWith("softlic-");

      // Don't remove prefixes — keep full key as-is
      const keyid = key;

      // Use stripped keyid only for lookup
      const cleanKey = key.replace(/^input-/, "").replace(/^compd-/, "").replace(/^softlic-/, "");

      // Identify correct source for label
      const chargeItem = isInputKey
        ? chargenm?.find(item => item.keyid === cleanKey)
        : null;

      const compItem = isCompdKey
        ? compd?.find(item => item.keyid === cleanKey)
        : null;

      const label =
        typeof value === "object" && value.label
          ? value.label
          : chargeItem?.chargenm || compItem?.details || softlic?.softnm || `Unknown (${key})`;

      const price = typeof value === "object" ? value.price : value;
      if (topRef.current) {
        topRef.current.scrollIntoView({ behavior: "smooth", block: "start" }); // ✅ Smooth scroll to top
      }
      return {
        keyid,     // KEEP full key with prefix
        label,
        price: price ? parseFloat(price).toFixed(2) : "0.00",
        ...(value?.userCount && { userCount: value.userCount.toString() }) // ✅ Include only if present
      };

    });

    localStorage.setItem("quotationData", JSON.stringify(combinedData));
    setEnablePrintQuotation(isSaveEnabled()); // Update print button state
    setShowModTips("<h2>Quotation saved! You can now print or email it.</h2>");
    // setShowModTips(<pre className="form-label text-dark fw-bold h4" style={{ backgroundColor: "transparent", padding: 0, border: "none", fontFamily: 'inherit', color: 'inherit' }}>
    //   {`Quotation saved!\n\nYou can now print or email it.`}</pre>);
    console.log("Quotation saved:", JSON.stringify(combinedData)); // Debugging log
  };

  const handlePrintQuotation = () => { //Print quotation button
    const savedData = JSON.parse(localStorage.getItem("quotationData")) || [];
    setEmailData(savedData);
    setEmailFlag(true); // Trigger email hook
    setShowModTips("<h2>Quotation ready to be emailed!</h2>");
    console.log("Email data set:", JSON.stringify(savedData, null, 2));
    if (topRef.current) {
      topRef.current.scrollIntoView({ behavior: "smooth", block: "start" }); // ✅ Smooth scroll to top
    }
    if (savedData.length > 0) {
      // For screen display only — show as plain preview (optional)
      const preview = savedData.map(item => {
        const line = `${item.label}`;
        return item.tips ? `${line}\n💡 Tip: ${item.tips}` : line;
      }).join('\n');

      setShowModTips({ preview });
      // <pre style={{ backgroundColor: "transparent", padding: 0, border: "none", fontFamily: "inherit", color: "inherit" }}>
      //   {preview}
      // </pre>
      //      );

    } else {
      setShowModTips("No saved quotation found.");
    }
  };

  //email hook
  useEffect(() => {
    const msub = "ICLIGM Software Quotation";
    async function sendMailfunc() {
      console.log("Sending email with data:", compregkeyid);
      setShowModTips("Sending quotation email...");
      //          let temp_email="amar@eximon.com";
      try {
        const response = await fetch(`https://servguest.eximon.com/SqServlet?app=React_emailSend_Quots&compregkeyid=${encodeURIComponent(compregkeyid)}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            email: email, //temp_email
            sub: msub,
            company: companyName,
            totalAmount: Math.round(totalAmt).toString(),
            category: 'ICLIGM Quotation',
            data: emailData,
          }),
        });
        if (!response.ok) {
          console.log('Network response was not OK');
        }
        console.log('🔍 Fetch URL:', response);
        console.log('📦 Request Body:', JSON.stringify(response.body, null, 2));

        const responseData = await response.text();
        // Process the responseData as needed
        console.log('mailsend Data received:', responseData);
        const lines = responseData.split('\n');

        let sqlflag = '';
        let email_sent = ''
        for (let line of lines) { //Data
          if (line.trim().startsWith("sqlflag")) {
            sqlflag = line.trim().substring(7);
            console.log("sqlflag:" + sqlflag);
          }
          if (line.trim().startsWith("email_sent")) {
            email_sent = line.trim().substring(10);
            console.log("email_sent:" + email_sent);
          }
        }
        if (sqlflag === 'true' && email_sent === 'true') {
          console.log("Mail sent successfully.");
          //store local storage with timestamp
          const timestamp = new Date().toLocaleString();
          localStorage.setItem("emailData", emailData);
          localStorage.setItem("emailTimestamp", timestamp);
          setEmailFlag(false);
          setForceDisable(true); // Disable Save button after sending email
          setEnablePrintQuotation(false); // Disable print button after sending email
          setShowModTips(`Quotation emailed successfully!`);
          setPageMsgs(`Quotation emailed successfully!`);
        }
        else {
          console.error('API error: Mail response not received!');
        }
      } catch (error) {
        console.error('API error:', error.message);
        setEmailFlag(false);
      }
    }
    if (emailFlag && email !== '' && emailData !== '') {
      sendMailfunc();
    }
    else {
      console.log("Email flag is false or emailData is empty, not sending email." + emailFlag + " " + emailData + " " + email);
    }
  }, [emailFlag, email, emailData, companyName, totalAmt, compregkeyid]);


  const handleInputChange = (e, keyid) => {
    const isValidInput = !isNaN(e.target.value) && Number(e.target.value) > 0; // Check if number and > 0
    setValidUsrs(isValidInput);
    console.log('valid users' + validUsrs);
    const userCount = e.target.value ? parseInt(e.target.value, 10) : 0; // Default to 0 if empty

    setInputValues((prev) => ({
      ...prev,
      [keyid]: e.target.value // Keep actual input value (including empty)
    }));

    if (keyid === "2") {
      const usrLicNos = usrlic.find(
        (nos) =>
          userCount >= parseInt(nos.fromf, 10) &&
          userCount <= parseInt(nos.tof, 10)
          && nos.pckeyid === "2"
      );

      if (usrLicNos) {
        const usersPrice = (userCount - 1) * parseFloat(usrLicNos.usrrt);

        setPriceMap((prev) => ({
          ...prev,
          [`input-${keyid}`]: {
            price: usersPrice,
            tips: "",
            userCount: userCount, // Store the actual user count
          }
        }));
        setBasert(usersPrice);
      } else {
        setPriceMap((prev) => ({
          ...prev,
          [`input-${keyid}`]: 0,
          tips: "",
        }));
        setBasert(0);
      }
    }
  };

  useEffect(() => { //Total cost
    const total = Object.values(priceMap).reduce((acc, item) => {
      const val = typeof item === "object" ? item.price : item;
      return acc + Number(val || 0);
    }, 0);
    setTotalAmt(total);
    console.log("topRef", topRef.current);

    const hasCompd1 = priceMap.hasOwnProperty("compd-1");
    const hasCompd7 = priceMap.hasOwnProperty("compd-7");

    if (!hasCompd1 && !hasCompd7) {
      if (topRef.current) {
        topRef.current.scrollIntoView({ behavior: "smooth", block: "start" }); // ✅ Smooth scroll to top
      }
    }
    resetButton && SetResetButton(false); // Reset the button state after calculating total

  }, [priceMap, resetButton]);

  useEffect(() => {
    if (showModTips) {
      setShowTips("");
    }
  }, [showModTips]);

  useEffect(() => {
    if (showTips) {
      setShowModTips("");
    }
  }, [showTips]);

  useEffect(() => { //DBA
    const dbaItem = softlic.find(item => item.pckeyid === "8");
    if (dbaItem && !resetButton) {
      console.log("DBA price", dbaItem.basert);
      setPriceMap(prev => ({
        ...prev,
        [`softlic-${dbaItem.keyid}`]: {
          price: dbaItem.basert,
          label: dbaItem.softnm,
          tips: "",
        }
      }));
    }
    else {
      console.log("DBA not found or resetButton is true, skipping price update");
    }
  }, [softlic, resetButton]);

  return (
    <div id="icligm_quots" name="icligm_quots" className="text-center" ref={topRef} style={{ padding: "20px" }}>
      <Helmet htmlAttributes={{ lang: "en" }}>
        {/* <title>ICLIGM Quotations - Enterprise Maritime Software</title> */}
        <link rel="canonical" href="https://eximon.com/#icligm_quotes" />
        <meta charSet="utf-8" />
        <meta name="description" content="Request quotations for ICLIGM enterprise software solutions including database, cloud, and chatbot services for importers, exporters, and maritime shipping companies." />

        {/* Open Graph */}
        <meta property="og:title" content="ICLIGM Quotations - Enterprise Maritime Software" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://eximon.com/#icligm_quotes" />
        <meta property="og:description" content="Get customized ICLIGM software quotations for database, cloud, and chatbot services designed for global trade and maritime businesses." />
        <meta property="og:image" content="https://eximon.com/img/apple-touch-icon.png" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="ICLIGM Quotations - Enterprise Maritime Software" />
        <meta name="twitter:description" content="Request ICLIGM software quotations for database, cloud, and chatbot services tailored for importers, exporters, and maritime shipping companies." />
        <meta name="twitter:image" content="https://eximon.com/img/apple-touch-icon.png" />
      </Helmet>
      <div className="container" >
        <div className="section-title" style={{ margin: "auto" }}>
          <h1>ICLIGM - Generate quotation</h1>
          <h2>Self help portal for ICLIGM Software services</h2>
          <p id='pageMsgs' style={{ textAlign: 'center' }}>{pageMsgs}</p>

        </div>
        {iquotAccessed && user && (
          <div className="form-group" >
            <div className="row d-flex align-items-start">
              <div className="col-md-6 d-flex">
                {chargenm.map((item, index) => {

                  return (

                    <div className="mb-3" key={item.keyid}>
                      <div className="d-flex align-items-center mt-2">

                        <div className="row">
                          <div className="col-md-6">
                            <label className="form-label fw-bold" htmlFor={`input-${item.keyid}`} > {item.chargenm}</label>
                          </div>
                          <div className="col-md-6 text-end">
                            <i className="fa-solid fa-question-circle" style={{ cursor: "pointer" }} onClick={() => setShowTips(item.tips)} ></i>
                          </div>
                        </div>

                      </div>

                      {item.keyid <= 2 ? (
                        <input
                          id={`input-${item.keyid}`}
                          className="form-control mb-2"
                          type="text"
                          value={
                            inputValues[item.keyid] !== undefined
                              ? inputValues[item.keyid]
                              : (item.keyid === "1" || item.keyid === "2" ? "1" : "")
                          }
                          readOnly={item.keyid === "1"}
                          onChange={(e) => handleInputChange(e, item.keyid)}
                          style={{ borderColor: validUsrs ? "green" : "#cc5500" }}
                        />
                      ) :

                        item.keyid === "8" ? (
                          <select
                            id={`input-${item.keyid}`}
                            className="form-control"
                            value="Yes"
                            disabled
                          >
                            <option value="Yes">Yes</option>
                          </select>
                        ) : (
                          <>
                            {item.keyid === "9" && (  //reports

                              <select id={`softlic-${item.keyid}`} className="form-control"
                                value={softlic.find(soft => soft.keyid === selectedRepoLot)?.softnm || ""}
                                onChange={(e) => {
                                  const selectedValue = e.target.value;
                                  // Remove previous selection if any
                                  if (selectedRepoLot) {
                                    setPriceMap((prev) => {
                                      const updated = { ...prev };
                                      delete updated[`softlic-${selectedRepoLot}`];
                                      return updated;
                                    });
                                  }
                                  const selectedSoft = softlic.find(
                                    soft => soft.softnm === selectedValue && soft.pckeyid === "9"
                                  );
                                  if (selectedSoft) {
                                    setSelectedRepoLot(selectedSoft.keyid);
                                    setPriceMap((prev) => ({
                                      ...prev,
                                      [`softlic-${selectedSoft.keyid}`]: {
                                        price: selectedSoft.basert,
                                        label: selectedSoft.softnm,
                                        tips: ""
                                        //    tips: item.tips || ""
                                      }
                                    }));
                                    setBasert(selectedSoft.basert);
                                    setShowTips(item.tips);
                                  }
                                  else {
                                    setBasert(0);
                                    setShowTips("");
                                    setSelectedRepoLot(null);
                                  }
                                }}
                              >
                                <option value="">-- Select {item.chargenm} --</option>

                                {softlic
                                  .filter(
                                    (soft) => String(soft.pckeyid) === String(item.keyid)
                                  )
                                  .map((soft) => (
                                    <option key={soft.keyid} value={soft.softnm}>
                                      {soft.softnm}
                                    </option>
                                  ))}
                              </select>
                            )}
                            {item.keyid === "14" && (
                              <select id={`softlic-${item.keyid}`} className="form-control"
                                onChange={(e) => {
                                  const selectedItem = softlic.find(soft => soft.pckeyid === "14");
                                  if (selectedItem) {
                                    const value = e.target.value === "Yes" ? selectedItem.basert : 0;
                                    setPriceMap((prev) => ({
                                      ...prev,
                                      [`softlic-${selectedItem.keyid}`]: {
                                        price: value,
                                        label: selectedItem.softnm,
                                        tips: ""
                                      }
                                    }));
                                    setBasert(value);
                                    setShowTips(item.tips);
                                  }
                                }}
                              >
                                <option value="No">No</option>
                                <option value="Yes">Yes</option>
                              </select>

                            )}
                          </>

                        )}
                    </div>
                  );
                })}
              </div>
              <div className="col-md-6" >
                {/* {showTips && ( */}

                <div className="w-100">
                  {/* Rupee icon centered, full width */}
                  <div className="text-center mb-3">
                    <i className="fa-solid fa-indian-rupee-sign fs-1"></i>
                  </div>

                  <div className="row mb-2">
                    <div className="col-md-6">

                      <span className="fw-bold">Price</span>
                      <hr className="mt-0 mb-0" />
                      <h2 className="mb-0">{basert}</h2>
                    </div>

                    <div className="col-md-6" >

                      <span className="fw-bold">Total</span>
                      <hr className="mt-0 mb-0" />
                      <h2 className="mb-0">{totalAmt}</h2>
                    </div>
                  </div>


                </div>
                {showTips && (
                  <>
                    <hr className="mt-0 mb-1" />
                    <div
                      style={{ textAlign: "left", maxHeight: "100px", overflowY: "auto" }} dangerouslySetInnerHTML={{ __html: showTips }}
                    />
                  </>
                )}

              </div>
            </div>

            <div className="row mt-3">

              <div className="col-md-6">
                <hr className="w-100 mt-2 mb-2" />
                {softlic //Modules
                  .filter(item => item.pckeyid === "1")
                  .map(item => (
                    <div
                      key={item.keyid}
                      className="row"
                    >
                      <div className="col-md-6">
                        <label htmlFor={`checkbox-${item.keyid}`} className="form-label text-dark fw-bold h5">
                          {item.softnm}
                        </label>
                      </div>
                      <div className="col-md-6">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id={`checkbox-${item.keyid}`}
                          checked={typeof priceMap[`softlic-${item.keyid}`] !== 'undefined'}
                          onChange={(e) => {

                            const selectedMod = softlic.find(soft => soft.keyid === item.keyid);
                            if (!selectedMod) return;

                            const keyName = `softlic-${selectedMod.keyid}`;
                            setPriceMap((prev) => {
                              let updated = { ...prev };

                              if (e.target.checked) {
                                if (selectedMod.keyid === "26") {
                                  // Uncheck all other checkboxes with pckeyid === "1"
                                  softlic.forEach(mod => {
                                    if (mod.pckeyid === "1") {
                                      delete updated[`softlic-${mod.keyid}`];
                                    }
                                  });
                                }
                                else if (selectedMod.keyid === "3") { //Only IGM-EGM
                                  // Uncheck Import and Export modules if only IGM-EGM selected
                                  softlic.forEach(mod => {
                                    if (mod.keyid === "1" || mod.keyid === "2" || mod.keyid === "26" || mod.keyid === "29") {
                                      delete updated[`softlic-${mod.keyid}`];
                                    }
                                  });
                                }
                                else if (selectedMod.keyid === "29") { // Single location IGM-EGM cloud
                                  // Uncheck Import, SaaS and Only IGM-EGM modules if only IGM selected
                                  softlic.forEach(mod => {
                                    if (mod.keyid === "3" || mod.keyid === "1" || mod.keyid === "2" || mod.keyid === "26" || mod.keyid === "27") {
                                      delete updated[`softlic-${mod.keyid}`];
                                    }
                                  });
                                }
                                else if (selectedMod.keyid === "1" || selectedMod.keyid === "2") {
                                  softlic.forEach(mod => {
                                    if (mod.keyid === "3" || mod.keyid === "29" || mod.keyid === "26") {
                                      delete updated[`softlic-${mod.keyid}`];
                                    }
                                  });
                                }
                                else if (selectedMod.keyid === "27") { //Cloud back-end
                                  softlic.forEach(mod => {
                                    if (mod.keyid === "29" || mod.keyid === "26") {
                                      delete updated[`softlic-${mod.keyid}`];
                                    }
                                  });                                                                                                       
                                }

                                else {
                                  // If any other checkbox is checked and 26 was present, remove 26
                                  delete updated["softlic-26"];
                                  //                                  delete updated["softlic-3"];
                                }
                                // Add selected
                                updated[keyName] = {
                                  price: selectedMod.basert,
                                  label: selectedMod.softnm,
                                  tips: ""
                                };
                              } else {
                                // Remove if unchecked
                                delete updated[keyName];
                              }

                              return updated;
                            });
                            if (e.target.checked) {
                              setBasert(selectedMod.basert);
                              setShowModTips(item.tips);
                            } else {
                              setBasert(0); // Or you can keep the last one selected if needed
                              setShowModTips("");
                            }
                          }}
                        />
                      </div>
                    </div>
                  ))}
              </div>
              <div className="col-md-6 show-mod-tips" style={{ maxHeight: "250px", overflowY: "auto" }}>
                {showModTips && (
                  <div className="w-100">
                    <hr className="mt-0 mb-1" />
                    <div
                      style={{ textAlign: "left" }}
                      dangerouslySetInnerHTML={{ __html: showModTips }}
                    />
                  </div>
                )}
              </div>
            </div>

            <div className="row mt-4" >
              {compd && compd.map((item) => {
                let options = [];
                switch (item.keyid) {
                  case "1":
                    options = ["Pvt. Ltd.", "Limited", "MNC", "Government", "Defence"];
                    break;
                  case "7":
                    options = ["Shipping Agency / NVOCC", "Shipping Line", "Container Line"];
                    break;

                  default:
                    return null;
                }

                return (
                  <div key={item.keyid} className="col-md-6 mb-3">
                    <label className="form-label fw-bold h5 text-dark">
                      {item.details}
                    </label>
                    <select id={`compd-${item.keyid}`}
                      className="form-control"
                      onChange={(e) => {
                        const selected = e.target.value;
                        const selectedItem = compd.find(comp => comp.keyid === item.keyid);
                        if (!selectedItem) return;
                        // Update priceMap with selected value
                        setPriceMap((prev) => ({
                          ...prev,
                          [`compd-${item.keyid}`]: {
                            label: `${item.details} (${selected})`,
                            price: selected ? item.comprt : 0,
                            tips: ""
                          },
                        }));
                        setBasert(selected ? item.comprt : 0);
                        setShowModTips(item.tips);
                      }}
                    >
                      <option value="">-- Select {item.details} --</option>
                      {options.map((opt, idx) => (
                        <option key={idx} value={opt}>
                          {opt}
                        </option>
                      ))}
                    </select>
                  </div>
                );
              })}
            </div>

          </div>
        )}
        {iquotAccessed && user && (
          <div className="btn-group mx-2 mt-4">
            <button
              className="btn btn-custom btn-md"
              onClick={handleSaveQuotation}
              id="saveQuotationButton"
              disabled={!isSaveEnabled()}
            >
              Save Quotation
            </button>
            <button
              className="btn btn-custom btn-md"
              onClick={handlePrintQuotation}
              id="printQuotationButton"
              disabled={!enablePrintQuotation}
            >
              Generate Quotation mail
            </button>
            <button id="resetQuotationButton" className="btn btn-custom btn-md" onClick={() => {
              localStorage.removeItem("quotationData")
              setShowModTips("Quotation reset successfully!")
              setInputValues({});
              setPriceMap({});
              setBasert(0);
              setTotalAmt(0);
              setShowTips("");
              setShowModTips("");
              SetResetButton(true);
              setEnablePrintQuotation(false); // Disable print button on reset
              //reset all selected dropdowns
              const selectElements = document.querySelectorAll('select');
              selectElements.forEach(select => {
                select.selectedIndex = 0; // Reset to first option
              });

            }}>
              Reset Quotation
            </button>

            <button
              id="signoutButton"
              className="btn btn-custom btn-md"
              onClick={() => {
                setSignout(true);
                setPageMsgs('Please login to access this page.');
                setUserData(null);
              }}
            >
              Sign out
            </button>
          </div>
        )}
      </div>

    </div>
  );
};